// extracted by mini-css-extract-plugin
export var csatScore = "_jo-5";
export var header = "_jo-1";
export var panelWrapper = "_jo-2";
export var postPreview = "_jo-3";
export var rightContent = "_jo-0";
export var wrappingText = "_jo-4";